import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getProjectNameHeader } from '@/utils/imUtils';

const baseUrl = envConfig.formalServer + '/plat/admin/im/friend/relation/';

function baseApi() {

    function query(data, projectName) {
        return Post(baseUrl + 'queryImFriendRelation', data, getProjectNameHeader(projectName));
    }

    return {
        query
    };
}

export const imFriendRelationshipApi = baseApi();
